// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__d4YWS","title":"Info_title__3hMIO","selects":"Info_selects__1LYpq","requiredAsterisk":"Info_requiredAsterisk__2fruJ"};